import moment from 'moment'

export function formatReportDateTime(value) {
  if (!value) return '-'

  if (typeof value === 'object') {
    const seconds = value.seconds ?? value._seconds
    const nanos = value.nanos ?? value._nanoseconds ?? 0
    if (typeof seconds === 'number') {
      const millis = seconds * 1000 + Math.floor(nanos / 1000000)
      return moment(new Date(millis)).format('YYYY/MM/DD HH:mm:ss')
    }
  }

  const m = moment(value)
  return m.isValid() ? m.format('YYYY/MM/DD HH:mm:ss') : '-'
}
